export default "__VITE_ASSET__CtbHek$o__"